const MEDIA_URL_KEYS = new Set([
    'avatar',
    'cover_photo',
    'avatar_thumbnail',
    'url',
    'thumbnail',
    'photo_url',
    'image',
    'signedUrl',
    'signed_url',
    'mediaUrl',
    'media_url',
    'thumbnailUrl',
    'thumbnail_url',
    'path',
    'photoPath',
    'photo_path',
    'profilePhoto',
    'coverPhoto',
]);

export function ensureAbsoluteMediaUrl(value: unknown): unknown {
    if (typeof value !== 'string' || value.length === 0) {
        return value;
    }

    if (value.startsWith('https://') || value.startsWith('http://')) {
        return value;
    }

    if (value.startsWith('//')) {
        return `https:${value}`;
    }

    return value;
}

export function normalizeMediaUrls<T>(data: T): T {
    if (Array.isArray(data)) {
        return data.map((item) => normalizeMediaUrls(item)) as T;
    }

    if (data !== null && typeof data === 'object') {
        const normalized: Record<string, unknown> = {};

        for (const [key, value] of Object.entries(data as Record<string, unknown>)) {
            normalized[key] = MEDIA_URL_KEYS.has(key)
                ? ensureAbsoluteMediaUrl(value)
                : normalizeMediaUrls(value);
        }

        return normalized as T;
    }

    return data;
}
